import { TemplateResponse } from '@ydistri/api-sdk';
import { useGetTemplatesQuery } from '../apis/apiApplication';
import { getSelectedProjectShortName } from '../apis/apiHeader';
import { skipToken } from '@reduxjs/toolkit/query';

export const useTemplate = (templateId: number): TemplateResponse | undefined => {
  const { template } = useGetTemplatesQuery(getSelectedProjectShortName() ?? skipToken, {
    selectFromResult: ({ data }) => {
      return { template: data?.find(template => template.id === templateId) };
    },
  });

  return template;
};
